export * as CREATE_QUOTE_PAGE from "./components/create-quote-page/consts";
export * as DATES from "./utils/date-constants";
export * as IPM from "./components/ipm/ipm-constants";
export * as MAP from "./components/quote-transaction-component/quote-utility/components/property-insights/property-viewer/map-view/map-constants";
export * as MESSAGES from "./components/messages/constants";
export * as PAYMENT_PROCESSOR from "./units/payment-processor/constants";
export * as POLICY_CONST from "./components/policy-constants";
export * as POLICY_OPTIMIZATIONS from "./components/policy-view/policy-optimizations/constants";
export * as POLICY_VIEW from "./components/policy-view/constants";
export * as INSPECTION_WRITEOUTS from "./components/policy-view/policy-sections/underwriting-review/underwriting-review.constants";
export * as PRODUCER_DEFAULTS from "./components/producer-defaults/producer-defaults-constants";
export * as QTC from "./components/quote-transaction-component/qtc-constants";
export * as QUOTE_CONST from "./components/quote-constants";
export * as QUOTE_HOME from "./components/quote-home/quote-home-constants";
export * as TOOLS from "./components/tools/tools-constants";
export * as MORTGAGEE_CHANGE from "./components/policy-view/policy-modals/mortgagee-change/constants";
export * as RESOURCES from "./components/resources/resources.constants";
export * from "./components/quote-transaction-component/qtc-step-loss-history/qtc-loss-history-constants";

export const LOADING_STATES = {
  PRELOAD: "PRELOAD",
  LOADING: "LOADING",
  LOADED: "LOADED",
  LOAD_ERROR: "LOAD_ERROR"
};

// TODO There are some constants need to refactor in this file: /static-data/loading-state-enum"

// certain product properties and inputs has the value 100 referencing the boolean true and 200 referencing false
// before you use these constants, make sure you're certain these properties/inputs reference boolean values
export const PRODUCT = {
  Values: {
    True: "100",
    False: "200"
  }
};

export const LD_CONTEXT_KINDS = {
  USER: "user",
  ORGANIZATION: "organization",
  DEVICE: "device"
};

export const LD_USER_DEFAULT_CONTEXT = {
  kind: LD_CONTEXT_KINDS.USER,
  key: "agentportal"
};
